// Outlaw's Loot — Phase 3 asset map (client art handoff V1).
// All paths are served statically from /public/games/outlaws-loot/.
// Symbol keys map EXACTLY to backend symbol IDs — never rename or substitute.

const BASE = "/games/outlaws-loot/assets";
const AUDIO = "/games/outlaws-loot/audio/placeholders";

export const IMG = {
  background: `${BASE}/backgrounds/complete_saloon_background.png`,
  logo: `${BASE}/branding/outlaws_loot_logo.png`,
  mascot: `${BASE}/characters/goldhand_full.png`,
  cabinet: `${BASE}/frames/three_reel_cabinet.png`,
  goldRushHeader: `${BASE}/ui/gold_rush_free_plays_header.png`,
  freePlaysRemaining: `${BASE}/ui/free_plays_remaining_meter.png`,
  startFreePlay: `${BASE}/ui/start_free_play_button.png`,
  freePlayButton: `${BASE}/ui/free_play_button.png`,
  betCoin: `${BASE}/ui/bet_coin_button.png`,
  betPlus: `${BASE}/ui/bet_plus_button.png`,
  betMinus: `${BASE}/ui/bet_minus_button.png`,
  creditMeter: `${BASE}/ui/credit_meter.png`,
  betMeter: `${BASE}/ui/bet_meter.png`,
  winMeter: `${BASE}/ui/win_meter.png`,
  menuBtn: `${BASE}/ui/menu_button.png`,
  soundBtn: `${BASE}/ui/sound_button.png`,
};

export const JACKPOT_METER = {
  MINI: `${BASE}/jackpot_meters/MINI_meter_frame.png`,
  MINOR: `${BASE}/jackpot_meters/MINOR_meter_frame.png`,
  MAJOR: `${BASE}/jackpot_meters/MAJOR_meter_frame.png`,
  MEGA: `${BASE}/jackpot_meters/MEGA_meter_frame.png`,
};

export const EFFECT = {
  coinBurst: `${BASE}/effects/coin_burst.png`,
  coinSwirl: `${BASE}/effects/coin_swirl.png`,
  glowRing: `${BASE}/effects/gold_glow_ring.png`,
  goldDust: `${BASE}/effects/burgundy_gold_dust.png`,
};

export const SYMBOL = {
  GOLDHAND: `${BASE}/symbols/GOLDHAND.png`,
  GOLD_HAND: `${BASE}/symbols/GOLD_HAND.png`,
  WILD: `${BASE}/symbols/WILD.png`,
  BONUS: `${BASE}/symbols/BONUS.png`,
  GOLD_BARS: `${BASE}/symbols/GOLD_BARS.png`,
  GOLD_COINS: `${BASE}/symbols/GOLD_COINS.png`,
  BULL_BUCKLE: `${BASE}/symbols/BULL_BUCKLE.png`,
  HORSESHOE: `${BASE}/symbols/HORSESHOE.png`,
  RED_7: `${BASE}/symbols/RED_7.png`,
  TRIPLE_BAR: `${BASE}/symbols/TRIPLE_BAR.png`,
  DOUBLE_BAR: `${BASE}/symbols/DOUBLE_BAR.png`,
  SINGLE_BAR: `${BASE}/symbols/SINGLE_BAR.png`,
  MINI: `${BASE}/symbols/MINI.png`,
  MINOR: `${BASE}/symbols/MINOR.png`,
  MAJOR: `${BASE}/symbols/MAJOR.png`,
  MEGA: `${BASE}/symbols/MEGA.png`,
};

export const symbolSrc = (id) => SYMBOL[id] || SYMBOL.SINGLE_BAR;

// Payline SVG overlays (backend zero-based payline index -> asset).
export const PAYLINE_SVG = {
  0: `${BASE}/paylines/payline_01.svg`,
  1: `${BASE}/paylines/payline_02.svg`,
  2: `${BASE}/paylines/payline_03.svg`,
  3: `${BASE}/paylines/payline_04.svg`,
  4: `${BASE}/paylines/payline_05.svg`,
};

// Exact backend payline cell maps [reel0_row, reel1_row, reel2_row].
export const PAYLINE_CELLS = {
  0: [1, 1, 1], 1: [0, 0, 0], 2: [2, 2, 2], 3: [0, 2, 0], 4: [2, 0, 2],
};
export const PAYLINE_COLOR = {
  0: "#FFD34E", 1: "#49D9FF", 2: "#FF5555", 3: "#FF8A2B", 4: "#C96EFF",
};

// Audio event -> placeholder file (silent until final audio approved).
export const AUDIO_SRC = {
  ambient_loop: `/games/outlaws-loot/audio/saloon_bg.mp3`,
  reel_spin_start: `${AUDIO}/reel_spin_start.wav`,
  reel_stop: `${AUDIO}/reel_stop.wav`,
  nudge_trigger: `${AUDIO}/nudge_trigger.wav`,
  nudge_step: `${AUDIO}/nudge_step.wav`,
  base_win: `${AUDIO}/base_win.wav`,
  bonus_trigger: `${AUDIO}/bonus_trigger.wav`,
  free_play_start: `${AUDIO}/free_play_start.wav`,
  free_play_retrigger: `${AUDIO}/free_play_retrigger.wav`,
  jackpot_mini: `${AUDIO}/jackpot_mini.wav`,
  jackpot_minor: `${AUDIO}/jackpot_minor.wav`,
  jackpot_major: `${AUDIO}/jackpot_major.wav`,
  jackpot_mega: `${AUDIO}/jackpot_mega.wav`,
  button_press: `${AUDIO}/button_press.wav`,
  bet_change: `${AUDIO}/bet_change.wav`,
  ineligible: `${AUDIO}/ineligible.wav`,
};

// Symbols used only to populate the spinning blur strip (visual only).
export const SPIN_STRIP = [
  "GOLD_BARS", "SINGLE_BAR", "WILD", "RED_7", "DOUBLE_BAR", "HORSESHOE",
  "TRIPLE_BAR", "GOLD_COINS", "BULL_BUCKLE", "BONUS", "GOLD_HAND", "MINI",
];
